import { render, staticRenderFns } from "./ReportSidebarAddPayment.vue?vue&type=template&id=672c178e&"
import script from "./ReportSidebarAddPayment.vue?vue&type=script&lang=js&"
export * from "./ReportSidebarAddPayment.vue?vue&type=script&lang=js&"
import style0 from "./ReportSidebarAddPayment.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports